import { render, staticRenderFns } from "./opex_report.vue?vue&type=template&id=4516090e"
import script from "./opex_report.vue?vue&type=script&lang=js"
export * from "./opex_report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports